var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsEnum, IsNumber, IsOptional, IsString, } from 'class-validator';
import { GetManyQueryDto } from '../../../classes/common/request/get-many-query.dto';
import { BankCardType, SettlementState } from '../../../enums';
import { PartialType } from '../../../utils';
export class GetManySettlementsQueryDto extends PartialType(GetManyQueryDto) {
}
__decorate([
    IsEnum(SettlementState),
    IsOptional(),
    __metadata("design:type", String)
], GetManySettlementsQueryDto.prototype, "state", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManySettlementsQueryDto.prototype, "settledAt", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManySettlementsQueryDto.prototype, "vendorNameKeyword", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManySettlementsQueryDto.prototype, "vendorId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManySettlementsQueryDto.prototype, "bankCardNameKeyword", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManySettlementsQueryDto.prototype, "bankCardId", void 0);
__decorate([
    IsEnum(BankCardType),
    IsOptional(),
    __metadata("design:type", String)
], GetManySettlementsQueryDto.prototype, "bankCardType", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManySettlementsQueryDto.prototype, "managerId", void 0);
